import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import PaymentSettingsViewSF from '../../components/accountSettings/payment/PaymentSettingsViewSF'

const PaymentSettingsPageUI = ({context, paymentMethodList, stripeApiKey, messageList, errorList, onPaymentSettingsChange}) =>
  <PrivatePageSF context={context} className='pg_acc_sub' backLink='/settings/account/prj' messageList={messageList} headerMessageKey='c_credit_card'>
    {
      !paymentMethodList && !stripeApiKey && !(errorList && errorList.length) > 0 &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      paymentMethodList && stripeApiKey && !(errorList && errorList.length) > 0 &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/settings/account/prj' messageList={messageList} titleMessageKey='c_credit_card' />
        <PaymentSettingsViewSF
          context={context}
          paymentMethodList={paymentMethodList}
          stripeApiKey={stripeApiKey}
          messageList={messageList}
          onPaymentSettingsChange={onPaymentSettingsChange}
        />
      </div>
    }
  </PrivatePageSF>

export default PaymentSettingsPageUI
